import { useState } from 'react'
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  CardActions,
  Container,
  TextField,
  InputAdornment,
  Chip,
  Button,
  Tabs,
  Tab,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material'
import {
  LibraryBooks,
  Search,
  Category,
  Article,
  VideoLibrary,
  Description,
  PictureAsPdf,
  GetApp,
  Visibility,
  Book,
  School,
  Gavel,
  Business,
  AccountBalance,
  MenuBook,
} from '@mui/icons-material'

// Dummy data
const dummyCategories = [
  { id: '1', name: 'Pháp luật Dân sự', icon: <Gavel />, count: 45, color: 'primary' },
  { id: '2', name: 'Pháp luật Thương mại', icon: <Business />, count: 38, color: 'secondary' },
  { id: '3', name: 'Pháp luật Hình sự', icon: <AccountBalance />, count: 32, color: 'error' },
  { id: '4', name: 'Pháp luật Lao động', icon: <School />, count: 28, color: 'info' },
  { id: '5', name: 'Tài liệu tham khảo', icon: <MenuBook />, count: 67, color: 'success' },
]

const dummyDocuments = [
  {
    id: '1',
    title: 'Bộ luật Dân sự 2015 - Toàn văn',
    category: 'Pháp luật Dân sự',
    type: 'pdf',
    size: '2.5 MB',
    uploadDate: '2024-01-15',
    views: 245,
    downloads: 89,
    description: 'Toàn văn Bộ luật Dân sự năm 2015, bao gồm tất cả các điều khoản và quy định hiện hành.',
    tags: ['Dân sự', 'Bộ luật', 'Quy định'],
  },
  {
    id: '2',
    title: 'Hướng dẫn soạn thảo hợp đồng dân sự',
    category: 'Pháp luật Dân sự',
    type: 'pdf',
    size: '1.8 MB',
    uploadDate: '2024-02-10',
    views: 189,
    downloads: 67,
    description: 'Tài liệu hướng dẫn chi tiết về cách soạn thảo các loại hợp đồng dân sự phổ biến.',
    tags: ['Hợp đồng', 'Hướng dẫn', 'Mẫu'],
  },
  {
    id: '3',
    title: 'Luật Thương mại 2005 - Cập nhật 2023',
    category: 'Pháp luật Thương mại',
    type: 'pdf',
    size: '3.2 MB',
    uploadDate: '2024-03-05',
    views: 312,
    downloads: 124,
    description: 'Luật Thương mại với các điều khoản đã được sửa đổi, bổ sung đến năm 2023.',
    tags: ['Thương mại', 'Cập nhật', 'Luật'],
  },
  {
    id: '4',
    title: 'Video bài giảng: Phân tích án lệ dân sự',
    category: 'Pháp luật Dân sự',
    type: 'video',
    size: '125 MB',
    uploadDate: '2024-01-20',
    views: 456,
    downloads: 234,
    description: 'Video bài giảng phân tích các án lệ quan trọng trong lĩnh vực dân sự, do GS. Nguyễn Văn A trình bày.',
    tags: ['Video', 'Án lệ', 'Bài giảng'],
  },
  {
    id: '5',
    title: 'Bộ luật Hình sự 2015 - Sửa đổi 2022',
    category: 'Pháp luật Hình sự',
    type: 'pdf',
    size: '2.9 MB',
    uploadDate: '2024-02-28',
    views: 278,
    downloads: 98,
    description: 'Bộ luật Hình sự với các điều khoản đã được sửa đổi, bổ sung theo Luật số 12/2022/QH15.',
    tags: ['Hình sự', 'Bộ luật', 'Sửa đổi'],
  },
  {
    id: '6',
    title: 'Tài liệu tham khảo: Các vụ án nổi tiếng',
    category: 'Tài liệu tham khảo',
    type: 'pdf',
    size: '4.1 MB',
    uploadDate: '2024-03-15',
    views: 389,
    downloads: 156,
    description: 'Tuyển tập các vụ án nổi tiếng trong lịch sử pháp luật Việt Nam, có phân tích chi tiết.',
    tags: ['Án lệ', 'Tham khảo', 'Lịch sử'],
  },
  {
    id: '7',
    title: 'Video: Kỹ năng tranh tụng tại tòa',
    category: 'Tài liệu tham khảo',
    type: 'video',
    size: '98 MB',
    uploadDate: '2024-01-30',
    views: 567,
    downloads: 289,
    description: 'Video hướng dẫn các kỹ năng tranh tụng hiệu quả tại tòa án, bao gồm cách trình bày và phản biện.',
    tags: ['Video', 'Kỹ năng', 'Tranh tụng'],
  },
  {
    id: '8',
    title: 'Luật Lao động 2019 - Toàn văn',
    category: 'Pháp luật Lao động',
    type: 'pdf',
    size: '2.1 MB',
    uploadDate: '2024-02-20',
    views: 201,
    downloads: 76,
    description: 'Toàn văn Luật Lao động năm 2019, bao gồm các quy định về hợp đồng lao động, tiền lương, bảo hiểm.',
    tags: ['Lao động', 'Luật', 'Quy định'],
  },
]

const dummyRecentUploads = [
  { id: '1', title: 'Bộ luật Dân sự 2015 - Toàn văn', date: '2024-01-15', category: 'Pháp luật Dân sự' },
  { id: '2', title: 'Hướng dẫn soạn thảo hợp đồng dân sự', date: '2024-02-10', category: 'Pháp luật Dân sự' },
  { id: '3', title: 'Luật Thương mại 2005 - Cập nhật 2023', date: '2024-03-05', category: 'Pháp luật Thương mại' },
]

const dummyPopularDocs = [
  { id: '4', title: 'Video bài giảng: Phân tích án lệ dân sự', views: 456, category: 'Pháp luật Dân sự' },
  { id: '7', title: 'Video: Kỹ năng tranh tụng tại tòa', views: 567, category: 'Tài liệu tham khảo' },
  { id: '3', title: 'Luật Thương mại 2005 - Cập nhật 2023', views: 312, category: 'Pháp luật Thương mại' },
]

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  )
}

export default function KnowledgeLibraryPage() {
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedCategory, setSelectedCategory] = useState<string>('all')
  const [tabValue, setTabValue] = useState(0)
  const [selectedDoc, setSelectedDoc] = useState<any>(null)
  const [detailDialogOpen, setDetailDialogOpen] = useState(false)

  const filteredDocs = dummyDocuments.filter((doc) => {
    const matchesSearch = doc.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         doc.description.toLowerCase().includes(searchQuery.toLowerCase())
    const matchesCategory = selectedCategory === 'all' || doc.category === selectedCategory
    return matchesSearch && matchesCategory
  })

  const handleViewDetail = (doc: any) => {
    setSelectedDoc(doc)
    setDetailDialogOpen(true)
  }

  const getTypeIcon = (type: string) => {
    return type === 'video' ? <VideoLibrary /> : <PictureAsPdf />
  }

  const getTypeColor = (type: string) => {
    return type === 'video' ? 'error' : 'primary'
  }

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <LibraryBooks sx={{ fontSize: 40, color: 'primary.main' }} />
          <Typography variant="h4" fontWeight="bold">
            Kho học liệu
          </Typography>
        </Box>
      </Box>

      {/* Search Bar */}
      <Paper sx={{ p: 2, mb: 4 }}>
        <TextField
          fullWidth
          placeholder="Tìm kiếm tài liệu, video, bài giảng..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </Paper>

      {/* Categories */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 2 }}>
          Danh mục
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          <Chip
            label="Tất cả"
            onClick={() => setSelectedCategory('all')}
            color={selectedCategory === 'all' ? 'primary' : 'default'}
            sx={{ height: 40, fontSize: '0.95rem' }}
          />
          {dummyCategories.map((cat) => (
            <Chip
              key={cat.id}
              icon={cat.icon}
              label={`${cat.name} (${cat.count})`}
              onClick={() => setSelectedCategory(cat.name)}
              color={selectedCategory === cat.name ? 'primary' : 'default'}
              sx={{ height: 40, fontSize: '0.95rem' }}
            />
          ))}
        </Box>
      </Box>

      {/* Tabs */}
      <Paper sx={{ mb: 4 }}>
        <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
          <Tab label="Tất cả tài liệu" />
          <Tab label="Tải lên gần đây" />
          <Tab label="Phổ biến nhất" />
        </Tabs>
      </Paper>

      {/* All Documents */}
      <TabPanel value={tabValue} index={0}>
        <Grid container spacing={3}>
          {filteredDocs.map((doc) => (
            <Grid item xs={12} sm={6} md={4} key={doc.id}>
              <Card elevation={3} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flex: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'start', gap: 2, mb: 2 }}>
                    <Avatar sx={{ bgcolor: `${getTypeColor(doc.type)}.main`, width: 48, height: 48 }}>
                      {getTypeIcon(doc.type)}
                    </Avatar>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="h6" fontWeight={600} gutterBottom>
                        {doc.title}
                      </Typography>
                      <Chip label={doc.category} size="small" sx={{ mb: 1 }} />
                    </Box>
                  </Box>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, minHeight: 40 }}>
                    {doc.description}
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
                    {doc.tags.map((tag, idx) => (
                      <Chip key={idx} label={tag} size="small" variant="outlined" />
                    ))}
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="caption" color="text.secondary">
                      {doc.size} • {new Date(doc.uploadDate).toLocaleDateString('vi-VN')}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        👁 {doc.views} • ⬇ {doc.downloads}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
                <CardActions sx={{ p: 2, pt: 0 }}>
                  <Button
                    size="small"
                    startIcon={<Visibility />}
                    onClick={() => handleViewDetail(doc)}
                  >
                    Xem chi tiết
                  </Button>
                  <Button
                    size="small"
                    startIcon={<GetApp />}
                    color="primary"
                  >
                    Tải xuống
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </TabPanel>

      {/* Recent Uploads */}
      <TabPanel value={tabValue} index={1}>
        <List>
          {dummyRecentUploads.map((doc, idx) => {
            const fullDoc = dummyDocuments.find(d => d.id === doc.id)
            return (
              <Box key={doc.id}>
                <ListItem
                  secondaryAction={
                    <Box>
                      <IconButton edge="end" onClick={() => handleViewDetail(fullDoc)}>
                        <Visibility />
                      </IconButton>
                      <IconButton edge="end">
                        <GetApp />
                      </IconButton>
                    </Box>
                  }
                >
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: `${getTypeColor(fullDoc?.type || 'pdf')}.main` }}>
                      {getTypeIcon(fullDoc?.type || 'pdf')}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={doc.title}
                    secondary={
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          {doc.category} • {new Date(doc.date).toLocaleDateString('vi-VN')}
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>
                {idx < dummyRecentUploads.length - 1 && <Divider />}
              </Box>
            )
          })}
        </List>
      </TabPanel>

      {/* Popular Documents */}
      <TabPanel value={tabValue} index={2}>
        <Grid container spacing={3}>
          {dummyPopularDocs.map((doc) => {
            const fullDoc = dummyDocuments.find(d => d.id === doc.id)
            return (
              <Grid item xs={12} sm={6} md={4} key={doc.id}>
                <Card elevation={3}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'start', gap: 2, mb: 2 }}>
                      <Avatar sx={{ bgcolor: `${getTypeColor(fullDoc?.type || 'pdf')}.main`, width: 48, height: 48 }}>
                        {getTypeIcon(fullDoc?.type || 'pdf')}
                      </Avatar>
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" fontWeight={600} gutterBottom>
                          {doc.title}
                        </Typography>
                        <Chip label={doc.category} size="small" />
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Chip 
                        icon={<Visibility />} 
                        label={`${doc.views} lượt xem`} 
                        size="small" 
                        color="primary"
                      />
                    </Box>
                  </CardContent>
                  <CardActions>
                    <Button size="small" startIcon={<Visibility />} onClick={() => handleViewDetail(fullDoc)}>
                      Xem chi tiết
                    </Button>
                    <Button size="small" startIcon={<GetApp />} color="primary">
                      Tải xuống
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      </TabPanel>

      {/* Detail Dialog */}
      <Dialog 
        open={detailDialogOpen} 
        onClose={() => setDetailDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        {selectedDoc && (
          <>
            <DialogTitle>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: `${getTypeColor(selectedDoc.type)}.main` }}>
                  {getTypeIcon(selectedDoc.type)}
                </Avatar>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6">{selectedDoc.title}</Typography>
                  <Chip label={selectedDoc.category} size="small" sx={{ mt: 0.5 }} />
                </Box>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary" paragraph>
                  {selectedDoc.description}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                {selectedDoc.tags.map((tag: string, idx: number) => (
                  <Chip key={idx} label={tag} size="small" variant="outlined" />
                ))}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body2">
                  <strong>Kích thước:</strong> {selectedDoc.size}
                </Typography>
                <Typography variant="body2">
                  <strong>Ngày tải lên:</strong> {new Date(selectedDoc.uploadDate).toLocaleDateString('vi-VN')}
                </Typography>
                <Typography variant="body2">
                  <strong>Lượt xem:</strong> {selectedDoc.views}
                </Typography>
                <Typography variant="body2">
                  <strong>Lượt tải xuống:</strong> {selectedDoc.downloads}
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDetailDialogOpen(false)}>
                Đóng
              </Button>
              <Button variant="contained" startIcon={<GetApp />}>
                Tải xuống
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Container>
  )
}
